import(/* webpackMode: "eager", webpackExports: ["YandexPayProvider"] */ "/app/src/app/layouts/YandexPayProvider/YandexPayProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductCategories"] */ "/app/src/screens/Main/ui/ProductCategories/ProductCategories.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/PageHead/PageHead.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/SeoText/SeoText.module.scss");
